import { applySignedIdsToContent } from '../../components/agreement-content-editor/uploadImage'
import { isAgreementHtmlEmpty, sanitizeAgreementHtml } from '../../utilities/sanitizeHtml'

export function getLinkExpirationDays (values) {
  if (!values.linkExpiration) return null
  if (values.linkExpiration === 'CUSTOM') {
    const days = parseInt(values.customDays, 10)
    return Number.isNaN(days) ? null : days
  }
  const days = parseInt(values.linkExpiration, 10)
  return Number.isNaN(days) ? null : days
}

/** Digits only, max 2 (same pattern as normalizePhone). */
export function normalizeCustomDays (value) {
  if (!value) {
    return value
  }
  return String(value).replace(/\D/g, '').slice(0, 2)
}

export function mapFormToInput (values, publish, isEnabled = true) {
  return {
    title: values.name.trim(),
    content: sanitizeAgreementHtml(applySignedIdsToContent(values.content)),
    warnOnTicketCreation: !!values.warnTicketCreation,
    warnOnInvoicePayment: !!values.warnInvoicePayment,
    signatureTrigger: values.signatureTrigger || null,
    deliveryMethod: values.defaultDelivery || null,
    linkExpirationDays: getLinkExpirationDays(values),
    notifyAdminOnSign: values.notifyAdminOnSign
      ? values.notifyAdminOnSign === 'YES'
      : null,
    isDefault: !!values.isDefault,
    isEnabled,
    publish
  }
}

export function validate (values) {
  const errors = {}

  // Draft and publish both require name + content.
  // Other fields are enforced for publish via hasRequiredSelectValues.
  if (!values.name?.trim()) {
    errors.name = 'Required'
  }
  if (isAgreementHtmlEmpty(values.content)) {
    errors.content = 'Required'
  }

  return errors
}

export function hasRequiredDraftValues (values) {
  return Boolean(values.name?.trim()) && !isAgreementHtmlEmpty(values.content)
}

export function hasRequiredSelectValues (values) {
  if (!values.signatureTrigger || !values.defaultDelivery || !values.linkExpiration || !values.notifyAdminOnSign) {
    return false
  }
  if (values.linkExpiration === 'CUSTOM') {
    const days = parseInt(values.customDays, 10)
    if (!values.customDays || Number.isNaN(days) || days < 1) {
      return false
    }
  }
  return true
}
